<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title">
          <div v-if="FormInputs.IndividualLabels || FormInputs.BusinessLabels">
            Association Information and Communication Preferences
          </div>
          <div v-if="FormInputs.NonProfitLabels">Communication Preferences</div>
        </div>
      </div>
      <div
        v-if="
          FormInputs.IndividualOrganization || FormInputs.BusinessOrganization
        "
        class="col-lg-12 col-md-12 col-sm-12 col-xs-12"
      >
        <!-- <label v-if="FormInputs.IndividualLabels">
                    Please select all of the professional organizations of which you are a member.
                </label> -->
        <label> Please select all of your professional affiliations. </label>
        <div class="row">
          <div
            class="col-lg-6 col-md-6 col-sm-12"
            v-for="(value, key, index) in CheckboxBusiness"
            :key="index"
            v-if="FormInputs.BusinessOrganization"
          >
            <div class="form-check">
              <label class="form-check-label">
                <input
                  :value="key"
                  v-model="Account.Organizations.List"
                  class="form-check-input"
                  type="checkbox"
                />
                {{ key }}
              </label>
            </div>
          </div>
        </div>

        <div
          v-for="(value, key) in CheckboxIndividual"
          class="form-check"
          v-if="FormInputs.IndividualOrganization"
        >
          <label class="form-check-label">
            <input
              :value="key"
              v-model="Account.Organizations.List"
              class="form-check-input"
              type="checkbox"
            />
            {{ key }}
          </label>
        </div>
        <div
          class="form-group"
          v-if="Account.Organizations.List.indexOf('Other') >= 0"
        >
          <p>
            Please enter any other professional organizations you are associated
            with separated by semicolon(;).
          </p>
          <input
            type="text"
            v-model="Account.Organizations.Others"
            class="form-control"
          />
        </div>
      </div>

      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 div_bottom">
        <label
          class="label-heading"
          v-if="
            FormInputs.IndividualOrganization || FormInputs.BusinessOrganization
          "
        >
          Communication Preferences
        </label>
        <p class="no-margin-bot">Please confirm communication preferences.</p>
        <div class="form-check">
          <label class="form-check-label">
            <input
              class="form-check-input"
              v-model="Account.ToBeContactedAsVolunteer"
              type="checkbox"
            />
            I would like to be contacted if there are volunteer opportunities in
            my area.
          </label>
          <label class="form-check-label">
            <input
              class="form-check-input"
              v-model="Account.ToReceiveNewsLetter"
              type="checkbox"
            />
            I would like email updates from OneSight EssilorLuxottica Foundation.
          </label>
        </div>
      </div>
    </div>

    <div v-if="Account.Organizations.List.includes('Team Vision')" class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="registration-title">
          <div>Team Vision Addendum *</div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="form-check">
          <label class="form-check-label">
            <input
              value="Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal."
              class="form-check-input"
              v-model="Account.Addendum"
              type="checkbox"
            />
            Participant authorizes TeamVision/EssilorLuxottica staff the ability to enter in charitable orders for qualified patients through the Changing Life through Lenses (CLTL) Portal.
          </label>
          <br/>
          <br/>
          <label class="form-check-label">
            <input
              value="Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc."
              class="form-check-input"
              v-model="Account.Addendum"
              type="checkbox"
            />
            Participant authorizes TeamVision/EssilorLuxottica the ability to receive reports based on the Participants CLTL activity, which may include, but is not limited to, quarterly volume of patients served through CLTL as well as breakdown of patients served by exam-only and complete eyeglasses, etc.
          </label>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
export default {
  props: ["Account", "CheckboxBusiness", "CheckboxIndividual", "FormInputs"],
  created() {
    var referral = sessionStorage.getItem('referralCode')
    if (referral === 'teamvision') {
      this.Account.Organizations.List.push('Team Vision')
    }
    
    if (this.FormInputs.IndividualOrganization || this.FormInputs.NonProfitOrganization) this.Account.IsOrderFrameKit = null;
  },
};
</script>



// WEBPACK FOOTER //
// AssociationAndCommunication.vue?61fbfb6a